import { render, staticRenderFns } from "./r-treasure-piece-config-table.vue?vue&type=template&id=2876074e"
import script from "./r-treasure-piece-config-table.vue?vue&type=script&lang=js"
export * from "./r-treasure-piece-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2876074e')) {
      api.createRecord('2876074e', component.options)
    } else {
      api.reload('2876074e', component.options)
    }
    module.hot.accept("./r-treasure-piece-config-table.vue?vue&type=template&id=2876074e", function () {
      api.rerender('2876074e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-piece-config-table.vue"
export default component.exports